import React from 'react';

import { Geometry } from '../../../../../../viewer/elements/geometry';
import { useNonce } from '../../../../../hooks/use-nonce';
import { useAsset } from '../../../hooks/use-asset';
import { Asset } from '../../components/asset-blocks/asset';
import { AreaBody } from './area-body';
import { AreaHeader } from './area-header';

type Props = {
  asset: Geometry;
};

const AreaAsset = (props: Props) => {
  const [_, refresh] = useNonce();
  const { assetSelected } = useAsset(props.asset, {
    onAssetChanged: refresh,
  });

  React.useEffect(() => {
    // Automatically load the asset when it is selected if it's not already loaded.
    if (assetSelected && props.asset.isReadyToLoad()) {
      props.asset.loadGeometry();
      refresh();
    }
  }, [assetSelected, props, props.asset, refresh]);

  React.useEffect(() => {
    props.asset.onMetaDataUpdated = refresh;

    return () => {
      props.asset.onMetaDataUpdated = undefined;
    };
  }, [props.asset, refresh]);

  return (
    <Asset asset={props.asset}>
      {{
        header: <AreaHeader asset={props.asset} />,
        content: <AreaBody asset={props.asset} refreshAsset={refresh} />,
      }}
    </Asset>
  );
};

export { AreaAsset, Props as AreaAssetProps };
